import loadable from '@loadable/component';

export const BusinessEntityFlowRootLoadable = loadable(() => import('./BusinessEntityFlowRoot'), {
  fallback: undefined,
  ssr: false,
});
